import React, { useEffect, useState } from "react";
import Nav from "../nav/Nav";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function CyberSecuritySolution() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  const isMobile = screenWidth <= 768;
  const isTablet = screenWidth > 768 && screenWidth <= 1024;
  const isDesktop = screenWidth > 1024;

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: isMobile ? 1 : isTablet ? 2 : 4,
    centerMode: isMobile,
    centerPadding: isMobile ? "15px" : "0px",
  };

  return (
    <>
      <div>
        {/* Styling for Boxes */}
        <style
          dangerouslySetInnerHTML={{
            __html: `
      .box {
        min-height: 120px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
      }

      .carousel-item-style {
        background: #0e082d;
        border-radius: 11px;
        /* padding: 15px;*/
        margin: 0 25px;
      }

      .carousel-item-style img {
        max-width: 100%;
        height: 120px;
        object-fit: contain;
      }

      .slick-slide > div {
        padding: 0 10px;
      }

      .secure-title {
        font-family: 'Oswald', sans-serif;
        font-weight: 700;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        line-height: 1.1;
      }

      @media (max-width: 768px) {
         .box {
        min-height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .carousel-item-style {
        background: #0e082d;
        border-radius: 11px;
        padding: 15px;
        margin: 0 10px;
        width: 150px !important;
      }

      .carousel-item-style img {
        max-width: 100%;
        height: 120px;
        object-fit: contain;
      }

      .slick-slide > div {
        padding: 0 10px;
      }

      .secure-title {
        font-family: 'Oswald', sans-serif;
        font-weight: 700;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        line-height: 1.1;
      }
      }
      .carousel-item-style {
  background: #0e082d;
  border-radius: 11px;
  padding: 15px;
  margin: 0 10px;
}

.box {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
}

.box img {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

@media (max-width: 768px) {
  .carousel-item-style {
    margin: 0 5px;
  }
}
  .slick-track {
  display: flex !important;
}

.slick-slide {
  height: auto !important;
}

.slick-list {
  overflow: hidden !important;
}

    `,
          }}
        />

        <div className="sub-banner-section-outer position-relative">
          <header>
            <Nav />
          </header>
          {/* SUB-BANNER SECTION */}
          <section className="banner-section position-relative">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="banner-section-content">
                    <h1 className="text-white">Cybersecurity Solutions</h1>
                    {/*<p class="text-#0e082d" data-aos="fade-right">Cybersecurity </p>*/}
                    <div className="btn_wrapper">
                      <span> Home </span>
                      <i
                        className="fa-solid fa-angles-right"
                        aria-hidden="true"
                      />
                      <span className="sub_span">Cybersecurity Solutions</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div
                    className="banner_image position-relative"
                    style={{ left: "60px !important" }}
                  >
                    <figure className="banner_main_image mb-0 left_right_shape">
                      <img src="./assets/images/security.png" alt />
                    </figure>
                    <figure className="banner_image_bottom_shape mb-0 position-absolute top_bottom_shape">
                      <img
                        src="./assets/images/sub_banner_image_bottom_shape.png"
                        alt
                        className="img-fluid"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <figure className="banner_top_shape mb-0 position-absolute top_bottom_shape">
            <img
              src="./assets/images/sub_banner_top_shape.png"
              alt
              className="img-fluid"
            />
          </figure>
          <figure className="banner_background_shape mb-0 position-absolute left_right_shape">
            <img src="./assets/images/sub_banner_background_shape.png" alt />
          </figure>
        </div>
        {/* PRODUCT SECTION */}
        <section
          className="services_section position-relative section position-relative"
          style={{ paddingTop: 0 }}
        >
          <div className="container align-items-center h-100">
            <div className="row position-relative" style={{ zIndex: 1000 }}>
              {/*  */}
              {/* <div class="col-12 col-lg-5">

              <div class="hover-effect" data-aos="fade-down">

                  <figure>

                      <img src="./assets/images/heavy.png" alt="" class="img-fluid hover-effect">

                  </figure>

              </div>

          </div> */}
              <div className="col-12" style={{ zIndex: "1 !important" }}>
                <div className="container pb-5 pt-2 text-light">
                  <h1 id="secops" />
                  <h1 className="mb-4 text-center secure-title">
                    Security Operations (SecOps)
                  </h1>
                  <div
                    id="carouselExampleIndicators"
                    className="carousel slide slide-dcc "
                    data-interval="false"
                    data-ride="carousel"
                  >
                    <ol className="carousel-indicators">
                      <li
                        data-target="#carouselExampleIndicators"
                        data-slide-to={0}
                        className="active"
                      />
                      <li
                        data-target="#carouselExampleIndicators"
                        data-slide-to={1}
                      />
                      <li
                        data-target="#carouselExampleIndicators"
                        data-slide-to={2}
                      />
                      <li
                        data-target="#carouselExampleIndicators"
                        data-slide-to={3}
                      />
                    </ol>
                    <div className="carousel-inner">
                      <div className="carousel-item active px-5">
                        <section className="mb-5">
                          <h2>Vulnerability Assessment</h2>
                          <p>
                            <strong>Our Approach:</strong> We systematically
                            identify and prioritize vulnerabilities across your
                            systems to reduce risk exposure and prevent
                            exploitation. By combining automated tools with
                            expert validation, we deliver precise, actionable
                            insights to strengthen your security posture.
                          </p>
                          <h5>Process:</h5>
                          <ol>
                            <li>
                              <strong>
                                Scope Definition &amp; Asset Identification
                              </strong>
                              <ul className="describe">
                                <li>
                                  Define the assessment scope, including
                                  systems, networks, applications, and
                                  endpoints.
                                </li>
                                <li>
                                  Create a comprehensive inventory of in-scope
                                  assets to ensure complete coverage.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Automated Scanning &amp; Threat Discovery
                              </strong>
                              <ul className="describe">
                                <li>
                                  Use industry-leading tools to scan for known
                                  vulnerabilities, misconfigurations, and
                                  outdated software.
                                </li>
                                <li>
                                  Detect issues across operating systems,
                                  services, ports, and applications.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Manual Validation &amp; Risk Analysis
                              </strong>
                              <ul className="describe">
                                <li>
                                  Manually verify high-impact or complex
                                  findings to eliminate false positives.
                                </li>
                                <li>
                                  Assess exploitability, potential impact, and
                                  relevance to the specific environment.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Reporting &amp; Remediation Guidance
                              </strong>
                              <ul className="describe">
                                <li>
                                  Prioritize vulnerabilities based on severity,
                                  risk context, and business impact.
                                </li>
                                <li>
                                  Deliver clear reports with technical details,
                                  risk levels, and tailored remediation
                                  recommendations.
                                </li>
                                <li>
                                  Support patch management strategies and
                                  security control improvements.
                                </li>
                              </ul>
                            </li>
                          </ol>
                          <p>
                            <strong>Powered By:</strong>{" "}
                          </p>
                          {/* Owl Carousel HTML */}
                          <div style={{ width: "100%" }}>
                            <Slider  {...settings}>
                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/nessus.png"
                                    alt="Nessus"
                                  />
                                </div>
                              </div>
                            </Slider>
                          </div>
                        </section>
                      </div>
                      <div className="carousel-item px-5">
                        <section className="mb-5">
                          <h2>Endpoint Detection (GazTecForge UEM)</h2>
                          <p>
                            <strong>Our Approach:</strong> We deliver a tailored
                            UEM platform that scales from small businesses to
                            government contracts, ensuring security and
                            operational efficiency.
                          </p>
                          <h5>Our UEM Process:</h5>
                          <ol>
                            <li>
                              <strong>
                                Device Enrollment and Configuration
                              </strong>
                              <ul className="describe">
                                <li>
                                  Seamlessly onboard devices across Windows,
                                  macOS, iOS, Android, Linux, and IoT platforms.
                                </li>
                                <li>
                                  Use automated enrollment and secure
                                  configuration policies via Microsoft Intune.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>Security Implementation</strong>
                              <ul className="describe">
                                <li>
                                  Deploy endpoint detection, antivirus, and
                                  compliance policies to protect against
                                  threats.
                                </li>
                                <li>
                                  Ensure compliance with standards like GDPR,
                                  HIPAA, and FedRAMP.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>Application Management</strong>
                              <ul className="describe">
                                <li>
                                  Automate app deployment, updates, and
                                  management across diverse endpoints.
                                </li>
                                <li>
                                  Support secure and scalable application
                                  delivery, including IoT devices.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>Real-Time Monitoring</strong>
                              <ul className="describe">
                                <li>
                                  Monitor device health and performance with
                                  real-time analytics.
                                </li>
                                <li>
                                  Use automated alerts for proactive issue
                                  resolution.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>Secure Access Control</strong>
                              <ul className="describe">
                                <li>
                                  Implement single sign-on (SSO) and
                                  multi-factor authentication (MFA).
                                </li>
                                <li>
                                  Ensure secure, zero-trust access to corporate
                                  resources.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>Remote Support</strong>
                              <ul className="describe">
                                <li>
                                  Provide fast, secure remote troubleshooting
                                  and device management.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>Centralized Management</strong>
                              <ul className="describe">
                                <li>
                                  Deliver a branded, cloud-based dashboard
                                  hosted on AWS.
                                </li>
                                <li>
                                  Enable unified control, reporting, and
                                  scalability across all devices.
                                </li>
                              </ul>
                            </li>
                          </ol>
                          <p>
                            <strong>Powered By:</strong>{" "}
                          </p>
                          <div style={{ width: "100%" }}>
                            <Slider  {...settings}>
                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/intune.png"
                                    alt="Intune"
                                  />
                                </div>
                              </div>

                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/bitdefender.png"
                                    alt="Bitdefender"
                                  />
                                </div>
                              </div>

                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/ibm-mass.png"
                                    alt="IBM Mass"
                                  />
                                </div>
                              </div>

                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/omnissa.png"
                                    alt="Omnissa"
                                  />
                                </div>
                              </div>

                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/manage-engine.png"
                                    alt="Manage Engine"
                                  />
                                </div>
                              </div>

                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/okta.png"
                                    alt="Okta"
                                  />
                                </div>
                              </div>
                            </Slider>
                          </div>
                        </section>
                      </div>
                      <div className="carousel-item px-5">
                        <section className="mb-5">
                          <h2>Penetration Testing</h2>
                          <p></p>
                          <h4>Our Approach:</h4>
                          We combine elite offensive security skills with
                          automation and simulations. Certified ethical hackers
                          assess your defenses with real-world techniques.
                          <p />
                          <p></p>
                          <h4>What We Do:</h4>
                          We simulate advanced cyberattacks using real-world
                          techniques, targeting your organization's most
                          critical assets. This includes external threats (like
                          remote attackers) and internal risks (like compromised
                          accounts or insider threats).
                          <p />
                          <p></p>
                          <h4>Why It Matters:</h4>
                          Penetration testing reveals not just if you’re
                          vulnerable, but how those vulnerabilities can be
                          exploited in practice — and what real-world damage
                          could follow. It provides proof of risk and
                          prioritizes fixes based on impact, not just
                          theoretical exposure.
                          <p />
                          <p></p>
                          <h4>Executive Insight:</h4>
                          This isn’t just a checklist exercise. Our penetration
                          testing shows how attackers think, move, and exploit
                          gaps in your environment. The process gives leadership
                          visibility into business-critical risks, validates the
                          effectiveness of existing controls, and guides
                          security investment with evidence-backed insights.
                          Ultimately, it helps answer the question: If we were
                          attacked tomorrow, how far could they get — and how
                          can we stop them?
                          <p />
                          <h5>Process:</h5>
                          <ol>
                            <li>
                              <strong>
                                Reconnaissance &amp; Target Mapping
                              </strong>
                              <ul className="describe">
                                <li>
                                  Collect public and internal data to identify
                                  exposed systems, users, and services.
                                </li>
                                <li>
                                  Build a detailed profile of your attack
                                  surface.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Vulnerability Discovery &amp; Exploitation
                              </strong>
                              <ul className="describe">
                                <li>
                                  Use automated tools and manual techniques to
                                  find and exploit weaknesses.
                                </li>
                                <li>
                                  Verify which vulnerabilities are truly
                                  exploitable.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Post-Exploitation &amp; Lateral Movement
                              </strong>
                              <ul className="describe">
                                <li>
                                  Explore attacker capabilities after initial
                                  breach.
                                </li>
                                <li>
                                  Include privilege escalation and access to
                                  sensitive systems or data.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Reporting &amp; Interactive Debrief
                              </strong>
                              <ul className="describe">
                                <li>
                                  Provide a detailed report with prioritized
                                  findings and remediation steps.
                                </li>
                                <li>
                                  Conduct live walkthroughs to explain attack
                                  paths and defense gaps.
                                </li>
                              </ul>
                            </li>
                          </ol>
                          <p>
                            <strong>Powered By:</strong>{" "}
                          </p>
                          <div style={{ width: "100%" }}>
                            <Slider  {...settings}>
                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/metasploit.png"
                                    alt="Metasploit"
                                  />
                                </div>
                              </div>

                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/burp-suite.png"
                                    alt="Burp Suite"
                                  />
                                </div>
                              </div>

                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/kali.png"
                                    alt="Kali Linux"
                                  />
                                </div>
                              </div>

                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/rapid-7.png"
                                    alt="Rapid7"
                                  />
                                </div>
                              </div>
                            </Slider>
                          </div>
                        </section>
                      </div>
                      <div className="carousel-item  px-5">
                        <section className="mb-5">
                          <h2>Government Risk and Compliance</h2>
                          <p>
                            <strong>Our Approach:</strong> We help align your
                            systems with government standards through gap
                            analysis, control implementation, and audit
                            preparation.
                          </p>
                          <h5>Process:</h5>
                          <ol>
                            <li>
                              <strong>Standards-Based Gap Analysis</strong>
                              <ul className="describe">
                                <li>
                                  Evaluate your current security posture against
                                  applicable government frameworks (e.g., NIST
                                  800-53, FISMA, FedRAMP).
                                </li>
                                <li>
                                  Identify control gaps, policy shortfalls, and
                                  areas of elevated risk.
                                </li>
                                <li>
                                  Prioritize findings based on compliance impact
                                  and business risk.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Policy, Procedure &amp; Documentation Review
                              </strong>
                              <ul className="describe">
                                <li>
                                  Assess existing security policies, SOPs, and
                                  governance documentation for completeness and
                                  alignment with regulatory expectations.
                                </li>
                                <li>
                                  Recommend revisions or create missing
                                  documentation to meet control requirements.
                                </li>
                                <li>
                                  Ensure roles and responsibilities are clearly
                                  defined across security and compliance
                                  functions.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Control Implementation &amp; Validation
                              </strong>
                              <ul className="describe">
                                <li>
                                  Assist with the implementation of technical,
                                  physical, and administrative controls tailored
                                  to your environment.
                                </li>
                                <li>
                                  Validate control effectiveness through
                                  testing, walkthroughs, or technical
                                  evaluation.
                                </li>
                                <li>
                                  Align configurations and practices with
                                  continuous monitoring requirements.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>Audit Readiness &amp; Reporting</strong>
                              <ul className="describe">
                                <li>
                                  Prepare audit-ready documentation, including
                                  control mappings, risk assessments, and
                                  evidence packages.
                                </li>
                                <li>
                                  Support internal reviews, third-party audits,
                                  or government assessments.
                                </li>
                                <li>
                                  Deliver compliance reports with actionable
                                  remediation plans and timelines.
                                </li>
                              </ul>
                            </li>
                          </ol>
                          <p>
                            <strong>Powered By:</strong>{" "}
                          </p>
                          <div style={{ width: "100%" }}>
                            <Slider  {...settings}>
                              <div className="item carousel-item-style me-2">
                                <img
                                  src="/assets/images/logos/rsa.png"
                                  alt="RSA"
                                />
                              </div>
                              <div className="item carousel-item-style me-2">
                                <img
                                  src="/assets/images/logos/service-now.png"
                                  alt="ServiceNow"
                                />
                              </div>
                              <div className="item carousel-item-style me-2">
                                <img
                                  src="/assets/images/logos/compliance-forge.png"
                                  alt="Compliance Forge"
                                />
                              </div>
                            </Slider>
                          </div>
                        </section>
                      </div>
                    </div>
                    <button
                      className="carousel-control-prev"
                      style={{ backgroundColor: "#ff000000", border: "none" }}
                      type="button"
                      data-target="#carouselExampleIndicators"
                      data-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      />
                      <span className="sr-only">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      style={{ backgroundColor: "#ff000000", border: "none" }}
                      type="button"
                      data-target="#carouselExampleIndicators"
                      data-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      />
                      <span className="sr-only">Next</span>
                    </button>
                  </div>
                  <h1 id="netops" />
                  <h1 className="my-4 text-center secure-title">
                    Network Operations (NetOps)
                  </h1>
                  <div
                    id="carouselNetworkIndicators"
                    className="carousel slide slide-dcc "
                    data-interval="false"
                    data-ride="carousel"
                  >
                    <ol className="carousel-indicators">
                      <li
                        data-target="#carouselNetworkIndicators"
                        data-slide-to={0}
                        className="active"
                      />
                      <li
                        data-target="#carouselNetworkIndicators"
                        data-slide-to={1}
                      />
                      <li
                        data-target="#carouselNetworkIndicators"
                        data-slide-to={2}
                      />
                      <li
                        data-target="#carouselNetworkIndicators"
                        data-slide-to={3}
                      />
                    </ol>
                    <div className="carousel-inner">
                      <div className="carousel-item active px-5">
                        <section className="mb-5">
                          <h2>Network Intrusion Analysis</h2>
                          <p>
                            <strong>Our Approach:</strong>
                            GazTech specializes in precise compromise
                            assessments, proactively hunting for signs of
                            current or past unauthorized access within your
                            network. Using advanced forensic techniques and
                            threat intelligence, we meticulously analyze network
                            traffic, logs, and artifacts to detect indicators of
                            compromise (IOCs), persistent threats, and hidden
                            attacker activity. Our tailored approach ensures
                            rapid identification of breaches, delivering clear,
                            actionable insights to eradicate threats and prevent
                            recurrence.
                          </p>
                          <h5>Process:</h5>
                          <ol>
                            <li>
                              <strong>
                                Data Collection &amp; Log Aggregation
                              </strong>
                              <ul className="describe">
                                <li>
                                  Collect network logs, traffic captures, and
                                  relevant security artifacts from across the
                                  environment.
                                </li>
                                <li>
                                  Consolidate data from multiple sources to
                                  enable accurate, timeline-based analysis.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                IOC Detection &amp; Threat Hunting
                              </strong>
                              <ul className="describe">
                                <li>
                                  Analyze data for indicators of compromise
                                  (IOCs), anomalies, and attacker TTPs.
                                </li>
                                <li>
                                  Correlate activity against known threat
                                  intelligence and prior incidents to identify
                                  patterns of persistent or repeated compromise.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Forensic Investigation &amp; Historical Analysis
                              </strong>
                              <ul className="describe">
                                <li>
                                  Reconstruct the sequence of events to
                                  determine initial access, lateral movement,
                                  and impacted systems.
                                </li>
                                <li>
                                  Cross-reference current findings with
                                  historical data to identify recurring
                                  techniques or overlooked breaches.
                                </li>
                                <li>
                                  Assess the full scope and impact of both
                                  current and past intrusions.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Reporting &amp; Remediation Guidance
                              </strong>
                              <ul className="describe">
                                <li>
                                  Deliver detailed reports outlining confirmed
                                  threats, risk exposure, and system-level
                                  insights.
                                </li>
                                <li>
                                  Provide remediation strategies and
                                  recommendations for strengthening defenses
                                  against similar future attacks.
                                </li>
                                <li>
                                  Support compliance and incident response
                                  documentation as needed.
                                </li>
                              </ul>
                            </li>
                          </ol>
                          <p>
                            <strong>Powered By:</strong>
                          </p>
                          <div style={{ width: "100%" }}>
                            <Slider  {...settings}>
                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/splunk.png"
                                    alt="Splunk"
                                  />
                                </div>
                              </div>

                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/crowd.png"
                                    alt="CrowdStrike"
                                  />
                                </div>
                              </div>
                            </Slider>
                          </div>
                        </section>
                      </div>
                      <div className="carousel-item px-5">
                        <section className="mb-5">
                          <h2>Network Performance Optimization</h2>
                          <p>
                            <strong>Our Approach:</strong>
                            We ensure optimal network performance by proactively
                            monitoring traffic patterns, detecting bottlenecks,
                            and resolving inefficiencies. Our approach enhances
                            network speed, reliability, and overall user
                            experience through continuous analysis and tuning.
                          </p>
                          <h5>Process:</h5>
                          <ol>
                            <li>
                              <strong>
                                KPI Definition &amp; Baseline Assessment
                              </strong>
                              <ul className="describe">
                                <li>
                                  Establish key performance indicators (KPIs)
                                  such as latency, jitter, packet loss, and
                                  bandwidth utilization.
                                </li>
                                <li>
                                  Conduct a baseline assessment to understand
                                  normal performance across critical links and
                                  services.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Traffic Monitoring &amp; Trend Analysis
                              </strong>
                              <ul className="describe">
                                <li>
                                  Continuously monitor real-time and historical
                                  traffic across network segments.
                                </li>
                                <li>
                                  Analyze usage trends, protocol distribution,
                                  and traffic flow to identify unusual spikes or
                                  congestion points.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Bottleneck Detection &amp; Issue Resolution
                              </strong>
                              <ul className="describe">
                                <li>
                                  Pinpoint sources of latency, dropped packets,
                                  or throughput degradation.
                                </li>
                                <li>
                                  Investigate root causes such as overloaded
                                  links, misconfigured QoS policies, or routing
                                  inefficiencies.
                                </li>
                                <li>
                                  Apply targeted fixes to restore optimal
                                  performance.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Configuration Tuning &amp; Reporting
                              </strong>
                              <ul className="describe">
                                <li>
                                  Optimize device configurations (e.g., routing,
                                  QoS, interface settings) based on observed
                                  performance data.
                                </li>
                                <li>
                                  Provide detailed reports with insights,
                                  trends, and recommendations for continuous
                                  improvement.
                                </li>
                                <li>
                                  Support capacity planning and future scaling
                                  decisions.
                                </li>
                              </ul>
                            </li>
                          </ol>
                          <p>
                            <strong>Powered By:</strong>
                          </p>
                          <div style={{ width: "100%" }}>
                            <Slider  {...settings}>
                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/solar-winds.png"
                                    alt="SolarWinds"
                                  />
                                </div>
                              </div>

                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/prtg.png"
                                    alt="PRTG"
                                  />
                                </div>
                              </div>
                            </Slider>
                          </div>
                        </section>
                      </div>
                      <div className="carousel-item px-5">
                        <section className="mb-5">
                          <h2>Network Configuration Management</h2>
                          <p>
                            <strong>Our Approach:</strong>
                            We secure and streamline your network by managing
                            both physical hardware and device configurations.
                            This includes auditing cabling, rack setups, and
                            hardware placements. We also optimize device
                            settings to ensure consistency and peak performance.
                            Our process aligns your infrastructure with
                            regulatory standards, keeping your network reliable
                            and compliant.
                          </p>
                          <h5>Process:</h5>
                          <ol>
                            <li>
                              <strong>Discovery &amp; Inventory</strong>
                              <ul className="describe">
                                <li>
                                  Identify and catalog all network-connected
                                  devices (e.g., switches, routers, wireless
                                  controllers).
                                </li>
                                <li>
                                  Capture current configuration snapshots to
                                  establish a baseline.
                                </li>
                                <li>
                                  Map device roles, firmware versions, and
                                  connectivity within the network.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Configuration Audit &amp; Policy Review
                              </strong>
                              <ul className="describe">
                                <li>
                                  Analyze configurations for misalignments,
                                  deprecated commands, or security
                                  vulnerabilities.
                                </li>
                                <li>
                                  Compare settings against best practices and
                                  internal policies.
                                </li>
                                <li>
                                  Identify drift from standard configurations
                                  and flag compliance risks.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>Automation &amp; Change Control</strong>
                              <ul className="describe">
                                <li>
                                  Implement automated configuration backups and
                                  versioning.
                                </li>
                                <li>
                                  Enable change tracking with real-time alerts
                                  for unauthorized or risky edits.
                                </li>
                                <li>
                                  Integrate with network orchestration tools for
                                  consistent deployment across devices.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Remediation &amp; Compliance Reporting
                              </strong>
                              <ul className="describe">
                                <li>
                                  Apply validated changes to correct
                                  misconfigurations or optimize performance.
                                </li>
                                <li>
                                  Standardize templates for device types and
                                  network segments.
                                </li>
                                <li>
                                  Generate audit-ready reports to demonstrate
                                  compliance with internal and regulatory
                                  standards.
                                </li>
                              </ul>
                            </li>
                          </ol>
                          <p>
                            <strong>Powered By:</strong>
                          </p>
                          <div style={{ width: "100%" }}>
                            <Slider  {...settings}>
                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/solar-winds-ncm.png"
                                    alt="SolarWinds NCM"
                                  />
                                </div>
                              </div>
                            </Slider>
                          </div>
                        </section>
                      </div>
                      <div className="carousel-item  px-5">
                        <section className="mb-5">
                          <h2>Firewall Deployment &amp; Management</h2>
                          <p>
                            <strong>Our Approach:</strong>
                            We fortify your network security by physically
                            deploying and configuring firewalls alongside
                            expertly managing rules and policies. Our team
                            ensures your devices are properly installed and
                            integrated into your infrastructure. Combined with
                            real-time threat monitoring and rule optimization,
                            we deliver continuous protection, operational
                            efficiency, and compliance with industry standards.
                          </p>
                          <h5>Process:</h5>
                          <ol>
                            <li>
                              <strong>Assessment &amp; Planning</strong>
                              <ul className="describe">
                                <li>
                                  Perform an on-site or remote assessment of
                                  your network infrastructure.
                                </li>
                                <li>
                                  Identify security needs, traffic patterns, and
                                  optimal firewall placement.
                                </li>
                                <li>
                                  Select appropriate hardware and define
                                  deployment architecture.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>Procurement &amp; Deployment</strong>
                              <ul className="describe">
                                <li>
                                  Source, stage, and pre-configure firewall
                                  appliances.
                                </li>
                                <li>
                                  Physically install devices at designated
                                  network points.
                                </li>
                                <li>
                                  Connect to network infrastructure and verify
                                  functionality through hands-on testing.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>Configuration &amp; Integration</strong>
                              <ul className="describe">
                                <li>
                                  Implement firewall rules, NAT policies, VPN
                                  tunnels, and segmentation.
                                </li>
                                <li>
                                  Integrate with existing systems (e.g., AD,
                                  DNS, SIEM) for unified security.
                                </li>
                                <li>
                                  Test policy enforcement, connectivity, and
                                  failover mechanisms.
                                </li>
                              </ul>
                            </li>
                            <li>
                              <strong>
                                Ongoing Management &amp; Monitoring
                              </strong>
                              <ul className="describe">
                                <li>
                                  Continuously monitor traffic, logs, and device
                                  health.
                                </li>
                                <li>
                                  Apply firmware updates, manage rule changes,
                                  and handle hardware support.
                                </li>
                                <li>
                                  Provide reporting, compliance documentation,
                                  and technical support as needed.
                                </li>
                              </ul>
                            </li>
                          </ol>
                          <p>
                            <strong>Powered By:</strong>
                          </p>
                          <div style={{ width: "100%" }}>
                            <Slider  {...settings}>
                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/fortine.png"
                                    alt="Fortinet"
                                  />
                                </div>
                              </div>

                              <div className="carousel-item-style">
                                <div className="box">
                                  <img
                                    src="/assets/images/logos/paloalto.png"
                                    alt="Palo Alto"
                                  />
                                </div>
                              </div>
                            </Slider>
                          </div>
                        </section>
                      </div>
                    </div>
                    <button
                      className="carousel-control-prev"
                      style={{ backgroundColor: "#ff000000", border: "none" }}
                      type="button"
                      data-target="#carouselNetworkIndicators"
                      data-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      />
                      <span className="sr-only">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      style={{ backgroundColor: "#ff000000", border: "none" }}
                      type="button"
                      data-target="#carouselNetworkIndicators"
                      data-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      />
                      <span className="sr-only">Next</span>
                    </button>
                  </div>
                </div>
              </div>
              <figure
                className="services_background_shape mb-0 position-absolute left_right_shape"
                style={{ zInde: "-1 !important" }}
              >
                <img
                  src="./assets/images/services_background_shape.png"
                  alt
                  className="img-fluid"
                />
              </figure>
            </div>
          </div>
          <figure className="services_right_shape mb-0 position-absolute top_bottom_shape">
            <img
              src="./assets/images/services_right_shape.png"
              alt
              className="img-fluid"
            />
          </figure>
        </section>
        {/* CONTACT MAP SECTION */}
        <div className="contact_map_section">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d462561.6574537445!2d55.22748795!3d25.076022449999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43496ad9c645%3A0xbde66e5084295162!2sDubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1699347606733!5m2!1sen!2sin"
                width="100%"
                height={450}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CyberSecuritySolution;
